import React from "react";
import { motion } from "framer-motion";
import {
  FaBookReader,
  FaMusic,
  FaPaintBrush,
  FaMicrophoneAlt,
  FaTheaterMasks,
  FaBrain,
  FaArrowRight,
  FaStar,
} from "react-icons/fa";

// ================= IMAGES =================
// Apni 5 images src/assets folder mein rakho

import activity1 from "../assets/activity1.jpeg";
import activity2 from "../assets/activity2.jpeg";
import activity3 from "../assets/activity3.jpeg";
import activity4 from "../assets/activity4.jpeg";
import activity5 from "../assets/activity5.jpeg";


// ================= ACTIVITIES =================

const activities = [
  {
    title: "Quiz",
    icon: <FaBrain />,
    desc: "Developing curiosity, knowledge, logical thinking and problem-solving skills.",
  },
  {
    title: "Music",
    icon: <FaMusic />,
    desc: "Encouraging creativity, rhythm, confidence and a love for musical expression.",
  },
  {
    title: "Drama",
    icon: <FaTheaterMasks />,
    desc: "Building communication, imagination, teamwork and stage confidence.",
  },
  {
    title: "Drawing",
    icon: <FaPaintBrush />,
    desc: "Helping students express their imagination and creativity through art.",
  },
  {
    title: "Elocution",
    icon: <FaMicrophoneAlt />,
    desc: "Improving public speaking, pronunciation and communication abilities.",
  },
  {
    title: "Recitation",
    icon: <FaBookReader />,
    desc: "Developing language skills, memory, expression and presentation.",
  },
];


export default function CoCurricular() {
  return (
    <section className="bg-[#f8fbff] overflow-hidden">

      {/* =====================================================
          HERO
      ===================================================== */}

      <section className="relative bg-gradient-to-r from-[#07294d] to-[#0b3d68] py-24 overflow-hidden">

        {/* Decorative circles */}

        <div className="absolute -top-24 -left-24 w-72 h-72 rounded-full bg-white/5"></div>

        <div className="absolute -bottom-32 -right-20 w-96 h-96 rounded-full bg-[#d4af37]/10"></div>

        <div className="absolute top-20 right-[15%] w-5 h-5 bg-[#d4af37] rounded-full opacity-60"></div>

        <div className="absolute bottom-16 left-[12%] w-3 h-3 bg-white rounded-full opacity-40"></div>


        <div className="max-w-6xl mx-auto px-6 text-center relative z-10">

          <motion.div
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >

            {/* Badge */}

            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 0.2, duration: 0.5 }}
              className="inline-flex items-center gap-2 px-5 py-2 rounded-full bg-white/10 border border-white/20 text-white text-sm font-semibold mb-7"
            >

              <FaStar className="text-[#d4af37]" />

              Beyond The Classroom

            </motion.div>


            <p className="uppercase tracking-[5px] text-[#d4af37] font-bold">
              Cambridge International School
            </p>


            <h1 className="text-5xl md:text-6xl lg:text-7xl font-black text-white mt-6">
              Co-Curricular
              <span className="block text-[#d4af37] mt-2">
                Activities
              </span>
            </h1>


            <div className="w-24 h-1 bg-[#d4af37] rounded-full mx-auto my-8"></div>


            <p className="max-w-2xl mx-auto text-white/75 text-lg leading-8">
              Discover, create, perform and express. Our co-curricular
              activities help students discover their talents and develop
              confidence beyond the classroom.
            </p>

          </motion.div>

        </div>

      </section>


      {/* =====================================================
          INTRODUCTION
      ===================================================== */}

      <section className="max-w-6xl mx-auto px-6 py-20">

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
          className="bg-white rounded-[35px] shadow-xl overflow-hidden"
        >

          <div className="grid lg:grid-cols-[0.35fr_1fr]">

            {/* LEFT ACCENT */}

            <div className="bg-gradient-to-b from-[#07294d] to-[#0b3d68] p-10 flex flex-col justify-center">

              <p className="text-[#d4af37] uppercase tracking-[4px] font-bold text-sm mb-4">
                Our Approach
              </p>

              <h2 className="text-4xl font-black text-white leading-tight">
                Learning
                <br />
                Beyond
                <br />
                Books
              </h2>

              <div className="w-16 h-1 bg-[#d4af37] rounded-full mt-7"></div>

            </div>


            {/* RIGHT CONTENT */}

            <div className="p-10 md:p-14">

              <h2 className="text-3xl md:text-4xl font-black text-[#07294d] mb-6">
                Co-Curricular Activities
              </h2>

              <div className="w-20 h-1 bg-[#d4af37] rounded-full mb-8"></div>

              <p className="text-gray-600 text-lg leading-9">
                Co-Curricular Activities play a permanent importance in the
                overall development of the students. These activities are
                structured and balanced with the scholastic educational
                curriculum so that every student gets an opportunity to
                learn beyond regular predefined subjects.
              </p>

              <p className="text-gray-600 text-lg leading-9 mt-5">
                From Quiz, Music and Drama to Drawing, Elocution and
                Recitation, students are encouraged to participate in a
                diverse range of activities. Each activity offered by the
                school is designed with a purpose, collectively aiming for
                the holistic growth of every child.
              </p>


              {/* HIGHLIGHTS */}

              <div className="grid grid-cols-2 md:grid-cols-3 gap-5 mt-10">

                <div>
                  <h3 className="text-3xl font-black text-[#07294d]">
                    06+
                  </h3>

                  <p className="text-gray-500 text-sm mt-1">
                    Activities
                  </p>
                </div>


                <div>
                  <h3 className="text-3xl font-black text-[#07294d]">
                    360°
                  </h3>

                  <p className="text-gray-500 text-sm mt-1">
                    Development
                  </p>
                </div>


                <div>
                  <h3 className="text-3xl font-black text-[#07294d]">
                    100%
                  </h3>

                  <p className="text-gray-500 text-sm mt-1">
                    Participation
                  </p>
                </div>

              </div>

            </div>

          </div>

        </motion.div>

      </section>


      {/* =====================================================
          ACTIVITIES
      ===================================================== */}

      <section className="max-w-7xl mx-auto px-6 pb-16">

        <div className="text-center mb-14">

          <p className="uppercase tracking-[4px] text-[#d4af37] font-bold text-sm">
            Explore & Discover
          </p>

          <h2 className="text-4xl md:text-5xl font-black text-[#07294d] mt-3">
            Our Activities
          </h2>

          <div className="w-20 h-1 bg-[#d4af37] rounded-full mx-auto mt-6"></div>

        </div>


        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-7">

          {activities.map((item, index) => (

            <motion.div
              key={index}
              initial={{ opacity: 0, y: 35 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{
                duration: 0.5,
                delay: index * 0.08,
              }}
              viewport={{ once: true }}
              whileHover={{ y: -10 }}
              className="group bg-white rounded-[28px] shadow-lg border border-gray-100 p-8 relative overflow-hidden"
            >

              {/* Background Number */}

              <span className="absolute top-5 right-6 text-5xl font-black text-[#07294d]/5">
                0{index + 1}
              </span>


              {/* ICON */}

              <div className="w-20 h-20 rounded-2xl bg-[#07294d]/10 text-[#07294d] flex items-center justify-center text-4xl mb-7 group-hover:bg-[#07294d] group-hover:text-white transition-all duration-300">
                {item.icon}
              </div>


              <h3 className="text-2xl font-bold text-[#07294d] mb-4">
                {item.title}
              </h3>


              <div className="w-14 h-1 bg-[#d4af37] rounded-full mb-5"></div>


              <p className="text-gray-600 leading-8">
                {item.desc}
              </p>


              <div className="flex items-center gap-2 mt-6 text-[#07294d] font-semibold text-sm">
                Explore

                <FaArrowRight className="group-hover:translate-x-2 transition-transform" />
              </div>

            </motion.div>

          ))}

        </div>

      </section>


      {/* =====================================================
          CREATIVE PHOTO GALLERY
      ===================================================== */}

      <section className="relative py-20 bg-[#f8fbff]">

        {/* Decorative background */}

        <div className="absolute top-0 left-0 w-72 h-72 bg-[#07294d]/5 rounded-full blur-3xl"></div>

        <div className="absolute bottom-0 right-0 w-80 h-80 bg-[#d4af37]/10 rounded-full blur-3xl"></div>


        <div className="max-w-7xl mx-auto px-6 relative z-10">

          {/* Heading */}

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
            viewport={{ once: true }}
            className="text-center mb-12"
          >

            <p className="uppercase tracking-[4px] text-[#d4af37] font-bold text-sm">
              Creativity • Confidence • Expression
            </p>

            <h2 className="text-4xl md:text-5xl font-black text-[#07294d] mt-3">
              Moments Beyond The Classroom
            </h2>

            <div className="w-20 h-1 bg-[#d4af37] rounded-full mx-auto mt-5"></div>

          </motion.div>


          {/* ================= GALLERY ================= */}

          <div className="grid grid-cols-12 gap-4 md:gap-6 items-center">

            {/* IMAGE 1 — LARGE */}

            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.7 }}
              viewport={{ once: true }}
              className="col-span-12 md:col-span-7 h-[330px] md:h-[470px] rounded-[30px] overflow-hidden shadow-xl group"
            >

              <img
                src={activity1}
                alt="School Activity"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />

            </motion.div>


            {/* RIGHT 4 IMAGES */}

            <div className="col-span-12 md:col-span-5 grid grid-cols-2 gap-4 md:gap-6">

              {/* IMAGE 2 */}

              <motion.div
                initial={{ opacity: 0, y: -30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                viewport={{ once: true }}
                className="h-[210px] md:h-[225px] rounded-[25px] overflow-hidden shadow-lg group"
              >

                <img
                  src={activity2}
                  alt="School Activity"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />

              </motion.div>


              {/* IMAGE 3 */}

              <motion.div
                initial={{ opacity: 0, y: -30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.1 }}
                viewport={{ once: true }}
                className="h-[210px] md:h-[225px] rounded-[25px] overflow-hidden shadow-lg group"
              >

                <img
                  src={activity3}
                  alt="School Activity"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />

              </motion.div>


              {/* IMAGE 4 */}

              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                viewport={{ once: true }}
                className="h-[210px] md:h-[225px] rounded-[25px] overflow-hidden shadow-lg group"
              >

                <img
                  src={activity4}
                  alt="School Activity"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />

              </motion.div>


              {/* IMAGE 5 */}

              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.3 }}
                viewport={{ once: true }}
                className="h-[210px] md:h-[225px] rounded-[25px] overflow-hidden shadow-lg group"
              >

                <img
                  src={activity5}
                  alt="School Activity"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />

              </motion.div>

            </div>

          </div>


          {/* BOTTOM LINE */}

          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.3 }}
            viewport={{ once: true }}
            className="flex justify-center items-center gap-4 mt-10"
          >

            <div className="w-16 h-[1px] bg-[#d4af37]"></div>

            <p className="text-[#07294d] font-semibold text-sm tracking-wide">
              Learning • Creating • Growing
            </p>

            <div className="w-16 h-[1px] bg-[#d4af37]"></div>

          </motion.div>

        </div>

      </section>


      {/* =====================================================
          FINAL MESSAGE
      ===================================================== */}

      <section className="py-20 bg-white">

        <div className="max-w-5xl mx-auto px-6 text-center">

          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.7 }}
            viewport={{ once: true }}
            className="bg-[#f8fbff] rounded-[35px] shadow-lg p-10 md:p-14"
          >

            <FaStar className="text-[#d4af37] text-4xl mx-auto mb-6" />

            <h2 className="text-3xl md:text-4xl font-black text-[#07294d]">
              Every Talent Deserves A Platform
            </h2>

            <div className="w-20 h-1 bg-[#d4af37] rounded-full mx-auto my-6"></div>

            <p className="text-gray-600 text-lg leading-8 max-w-3xl mx-auto">
              At Cambridge International School, we believe that education
              extends beyond textbooks. Through co-curricular activities,
              students discover their interests, express themselves and
              develop the confidence to become well-rounded individuals.
            </p>

          </motion.div>

        </div>

      </section>

    </section>
  );
}